import { SCREEN_HEIGHT } from 'src/app/utils/screen-size';

export const getMenuPlacement = () => {
  const isSmallScreen = window.innerHeight < SCREEN_HEIGHT.MEDIUM;
  return isSmallScreen ? 'right-start' : 'bottom';
};
